import React from "react";
import { ICommonIconProps } from "../interface";

const LocationIcon = ({ ...props }: ICommonIconProps) => {
  return (
    <svg
      width={props?.IconWidth || "30"}
      height={props?.IconHeight || "30"}
      viewBox="0 0 30 30"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M15 0C9.18152 0 4.45312 4.72852 4.45312 10.5469C4.45312 12.5156 4.99816 14.4317 6.03521 16.084L14.285 29.5849C14.4258 29.8134 14.6367 29.9541 14.8829 29.9892C15.2167 30.0419 15.5861 29.9013 15.7794 29.5673L24.0528 15.9434C25.0371 14.3262 25.5469 12.4454 25.5469 10.5469C25.5469 4.72852 20.8185 0 15 0ZM15 15.8203C12.047 15.8203 9.72656 13.4297 9.72656 10.5469C9.72656 7.64643 12.0996 5.27344 15 5.27344C17.9004 5.27344 20.2734 7.64643 20.2734 10.5469C20.2734 13.4121 17.9882 15.8203 15 15.8203Z"
        fill={props?.IconColor || "currentColor"}
      />
      <path
        d="M15 0V5.27344C17.9004 5.27344 20.2734 7.64643 20.2734 10.5469C20.2734 13.4121 17.9882 15.8203 15 15.8203V29.9995C15.2999 30.0064 15.6084 29.8627 15.7793 29.5673L24.0527 15.9434C25.0371 14.3262 25.5469 12.4454 25.5469 10.5469C25.5469 4.72852 20.8185 0 15 0Z"
        fill={props?.IconColor || "currentColor"}
      />
    </svg>
  );
};

export default LocationIcon;
